import { NavLink } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

import { SETTINGS_PAGE_ROUTE } from "@/lib/navigation";
import CollabAccessPage from "@/pages/admin/settings/CollabAccessPage";
import LlmSettingsSection from "@/pages/admin/settings/LlmSettingsSection";

const sections = [
  {
    path: SETTINGS_PAGE_ROUTE,
    label: "Gestion des acces",
    icon: ShieldCheck,
  },
];

const SettingsPage = () => {
  return (
    <div className="space-y-6" data-testid="settings-page">
      <section className="rounded-3xl border border-white/10 glass-heavy p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
              Administration
            </p>
            <h1 className="mt-2 text-2xl font-heading font-bold text-white">
              Paramètres
            </h1>
            <p className="mt-2 max-w-2xl text-sm text-slate-400">
              Centralisez les autorisations sensibles du Pilotage sans toucher au
              RBAC principal SUPER_ADMIN, ADMIN, RH et COLLAB.
            </p>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-3">
          {sections.map((section) => (
            <NavLink
              key={section.path}
              to={section.path}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 rounded-2xl border px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "border-lenvia-blue/30 bg-lenvia-blue/10 text-lenvia-blue"
                    : "border-white/10 bg-white/[0.03] text-slate-300 hover:bg-white/[0.06] hover:text-white"
                }`
              }
            >
              <section.icon className="h-4 w-4" />
              {section.label}
            </NavLink>
          ))}
        </div>
      </section>

      <LlmSettingsSection />
      <CollabAccessPage />
    </div>
  );
};

export default SettingsPage;
